import * as P from "fp-ts-routing";

export type ActivityRoute = {};

export const activityPageMatch = P.lit("activity");
